import { jsxs as a, jsx as e, Fragment as ee } from "react/jsx-runtime";
import { Button as Z, Box as I, Text as u, Stack as O, defineStyleConfig as q, FormControl as se, InputGroup as V, InputLeftElement as Fe, Image as H, Input as De, FormLabel as fe, FormHelperText as Le, FormErrorMessage as de, Flex as C, HStack as L, IconButton as ke, VStack as te, Divider as $, Spacer as Xe, keyframes as ve, InputRightElement as Ke, Collapse as qe, Drawer as et, DrawerOverlay as tt, DrawerContent as rt, DrawerHeader as nt, Radio as ye, Select as ot, extendTheme as Oe, defineStyle as it, PinInput as lt, PinInputField as at, useDisclosure as ct, RadioGroup as st, AlertDialog as dt, AlertDialogOverlay as gt, AlertDialogContent as ut, AlertDialogHeader as Mt, AlertDialogBody as ht, AlertDialogFooter as It, Checkbox as pt } from "@chakra-ui/react";
import { forwardRef as ge, useState as x, useRef as Y, useEffect as E, useCallback as w, useMemo as P, createElement as mt, useId as yt } from "react";
import { CloseIcon as ue, DeleteIcon as Dt, AddIcon as ft, ChevronDownIcon as Ue, ChevronLeftIcon as Ye } from "@chakra-ui/icons";
import { formatPrice as ce } from "@getjust/commons";
import { Controller as He } from "react-hook-form";
import Nt from "currency.js";
import { useDebouncedCallback as Qe } from "use-debounce";
import bt from "fuse.js";
import { createPortal as Be } from "react-dom";
import xt from "react-phone-number-input";
const We = ({ label: t, variant: n, onClick: r, Icon: o, ...i }) => (
  // <Box>
  /* @__PURE__ */ a(Z, { variant: n, onClick: r, gap: 1.5, ...i, children: [
    o && /* @__PURE__ */ e(o, {}),
    t
  ] })
);
We.defaultProps = {
  border: "md",
  variant: "primary",
  isLoading: !1
};
const Me = ({ variant: t, children: n, borderRadius: r, ...o }) => /* @__PURE__ */ e(
  I,
  {
    borderRadius: r ?? "0.875rem",
    padding: t === "gradient" ? "1px" : "",
    width: "100%",
    display: "flex",
    bgImage: t === "gradient" ? "linear-gradient(90deg, #8DE690 2.08%, #A5F0A3 18.23%, #A6ECD7 33.33%, #97DADA 51.56%, #B3DAE7 67.71%, #B6C9EC 83.33%, #879ACB 100%)" : "",
    children: /* @__PURE__ */ e(
      I,
      {
        bg: t === "gradient" ? "#FFF" : "transparent",
        borderRadius: r ?? "0.875rem",
        width: "100%",
        display: "flex",
        children: /* @__PURE__ */ e(
          I,
          {
            bgGradient: t === "gradient" ? "linear-gradient(90deg, rgba(141, 230, 144, 0.10) 2.08%, rgba(165, 240, 163, 0.10) 18.23%, rgba(166, 236, 215, 0.10) 33.33%, rgba(151, 218, 218, 0.10) 51.56%, rgba(179, 218, 231, 0.10) 67.71%, rgba(182, 201, 236, 0.10) 83.33%, rgba(135, 154, 203, 0.10) 100%), #FFF" : "#FFF",
            borderRadius: r ?? "0.875rem",
            width: "100%",
            display: "flex",
            ...o,
            children: n
          }
        )
      }
    )
  }
);
Me.defaultProps = {
  border: "md",
  variant: "primary"
};
const jt = ({ title: t, subtitle: n, children: r, hasBorder: o, uppercaseTitle: i, ...l }) => /* @__PURE__ */ a(
  I,
  {
    className: "leaf-card__container",
    p: 2,
    borderWidth: o ? "1px" : "inherit",
    borderRadius: o ? "lg" : "none",
    ...l,
    overflow: "hidden",
    children: [
      /* @__PURE__ */ a(I, { px: "1", children: [
        /* @__PURE__ */ e(
          u,
          {
            textTransform: i ? "uppercase" : "none",
            className: "leaf-card__title",
            fontSize: "lg",
            fontWeight: "500",
            lineHeight: "6",
            children: t
          }
        ),
        n ? /* @__PURE__ */ e(
          u,
          {
            className: "leaf-card__subtitle",
            color: "#8F8F8F",
            fontSize: "sm",
            fontWeight: "350",
            lineHeight: "5",
            dangerouslySetInnerHTML: { __html: n }
          }
        ) : null
      ] }),
      r ? /* @__PURE__ */ e(O, { className: "leaf-card__content", spacing: 2, pt: 4, children: r }) : null
    ]
  }
), zt = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMiA3LjU3NjkyQzEyIDcuODc1NjcgMTEuODgxMiA4LjE2MjQyIDExLjY3MDEgOC4zNzM3OUw4LjM3MzU4IDExLjY3MDNDOC4xNjIyIDExLjg4MTQgNy44NzU2NyAxMiA3LjU3NjkyIDEyQzcuMjc4MTggMTIgNi45OTE0MyAxMS44ODEyIDYuNzgwMDYgMTEuNjcwMUwwLjI0MTI5NSA1LjEzMTMzQzAuMTU3ODEzIDUuMDUwMTQgMC4wOTMxMTgyIDQuOTUxNjIgMC4wNTE3OTc5IDQuODQyNjhDMC4wMDk2Njk3NCA0LjczMTYyIC0wLjAwNzA5NDggNC42MTI1NCAwLjAwMjczMDkgNC40OTQxNkMwLjAwMzY4MDY3IDQuNDgyNzIgMC4wMDUwMzA5MSA0LjQ3MTMxIDAuMDA2Nzc5MDYgNC40NTk5NkwwLjUwMzg0OCAxLjIzMzIyQzAuNTIwODIyIDEuMDQ1ODQgMC42MDI5NDQgMC44Njk5MzUgMC43MzY0NCAwLjczNjQ0QzAuODY5OTM1IDAuNjAyOTQ0IDEuMDQ1ODQgMC41MjA4MjIgMS4yMzMyMiAwLjUwMzg0OEw0LjQ1OTk2IDAuMDA2Nzc5MDZDNC40NzEzMSAwLjAwNTAzMDkxIDQuNDgyNzIgMC4wMDM2ODA2NyA0LjQ5NDE2IDAuMDAyNzMwOUM0LjYxMjU0IC0wLjAwNzA5NDggNC43MzE2MiAwLjAwOTY2OTc0IDQuODQyNjggMC4wNTE3OTc5QzQuOTUxNjIgMC4wOTMxMTgyIDUuMDUwMTQgMC4xNTc4MTMgNS4xMzEzMyAwLjI0MTI5NUwxMS42NzAzIDYuNzgwMjdDMTEuODgxNCA2Ljk5MTY1IDEyIDcuMjc4MTggMTIgNy41NzY5MlpNMi42MzYzOSAzLjU1MTg5QzIuNjM2MzkgMy4wNDYyOCAzLjA0NjI3IDIuNjM2NCAzLjU1MTg4IDIuNjM2NEM0LjA1NzQ5IDIuNjM2NCA0LjQ2NzM3IDMuMDQ2MjggNC40NjczNyAzLjU1MTg5QzQuNDY3MzcgNC4wNTc1IDQuMDU3NDkgNC40NjczOCAzLjU1MTg4IDQuNDY3MzhDMy4wNDYyNyA0LjQ2NzM4IDIuNjM2MzkgNC4wNTc1IDIuNjM2MzkgMy41NTE4OVoiIGZpbGw9IiMxQzFDMUMiLz4KPC9zdmc+Cg==", At = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgdmlld0JveD0iMCAwIDMyIDMyIiBmaWxsPSJub25lIj4KICA8Y2lyY2xlIG9wYWNpdHk9IjAuMSIgY3g9IjE2IiBjeT0iMTYiIHI9IjE2IiBmaWxsPSJ1cmwoI3BhaW50MF9saW5lYXJfMTE2Nl84NDY1MCkiLz4KICA8ZGVmcz4KICAgIDxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhcl8xMTY2Xzg0NjUwIiB4MT0iMCIgeTE9IjE2IiB4Mj0iMzIiIHkyPSIxNiIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgogICAgICA8c3RvcCBvZmZzZXQ9IjAuMDIwODMzMyIgc3RvcC1jb2xvcj0iIzhERTY5MCIvPgogICAgICA8c3RvcCBvZmZzZXQ9IjAuMTgyMjkyIiBzdG9wLWNvbG9yPSIjQTVGMEEzIi8+CiAgICAgIDxzdG9wIG9mZnNldD0iMC4zMzMzMzMiIHN0b3AtY29sb3I9IiNBNkVDRDciLz4KICAgICAgPHN0b3Agb2Zmc2V0PSIwLjUxNTYyNSIgc3RvcC1jb2xvcj0iIzk3REFEQSIvPgogICAgICA8c3RvcCBvZmZzZXQ9IjAuNjc3MDgzIiBzdG9wLWNvbG9yPSIjQjNEQUU3Ii8+CiAgICAgIDxzdG9wIG9mZnNldD0iMC44MzMzMzMiIHN0b3AtY29sb3I9IiNCNkM5RUMiLz4KICAgICAgPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjODc5QUNCIi8+CiAgICA8L2xpbmVhckdyYWRpZW50PgogIDwvZGVmcz4KPC9zdmc+", wt = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgdmlld0JveD0iMCAwIDMyIDMyIiBmaWxsPSJub25lIj4KICA8Y2lyY2xlIG9wYWNpdHk9IjAuMyIgY3g9IjE2IiBjeT0iMTYiIHI9IjE2IiBmaWxsPSIjRTBFMEUwIi8+Cjwvc3ZnPg==", Ct = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgdmlld0JveD0iMCAwIDMyIDMyIiBmaWxsPSJub25lIj4KICA8Y2lyY2xlIG9wYWNpdHk9IjAuMDUiIGN4PSIxNiIgY3k9IjE2IiByPSIxNiIgZmlsbD0iI0VFNTgyOSIvPgo8L3N2Zz4=", _e = {
  border: "1px solid",
  borderColor: "gray.602",
  color: "fullBlack.900",
  borderRadius: "1.875rem",
  h: "14",
  pt: "3"
}, re = {
  p: "1px",
  borderRadius: "1.875rem"
}, ne = {
  bgGradient: "linear-gradient(90deg, #8DE690 2.08%, #A5F0A3 18.23%, #A6ECD7 33.33%, #97DADA 51.56%, #B3DAE7 67.71%, #B6C9EC 83.33%, #879ACB 100%)",
  bg: ""
}, oe = {
  bg: "danger.main !important",
  bgGradient: ""
}, ie = {
  bg: "gray.602 !important",
  bgGradient: ""
}, le = {
  bg: "gray.602 !important",
  bgGradient: ""
}, J = {
  bgGradient: "linear-gradient(90deg, rgba(141, 230, 144, 0.10) 2.08%, rgba(165, 240, 163, 0.10) 18.23%, rgba(166, 236, 215, 0.10) 33.33%, rgba(151, 218, 218, 0.10) 51.56%, rgba(179, 218, 231, 0.10) 67.71%, rgba(182, 201, 236, 0.10) 83.33%, rgba(135, 154, 203, 0.10) 100%), #FFF !important",
  bg: ""
}, X = {
  bg: "#FFF",
  bgGradient: ""
}, K = {
  bg: "#FFF",
  bgGradient: ""
}, U = {
  bg: "#FFF",
  bgGradient: ""
}, Pe = {
  bg: "#FFF !important",
  opacity: 1,
  color: "gray.701 !important"
}, St = {
  bg: "#FFF"
}, he = {
  borderRadius: "1.875rem",
  filter: "blur(4px)",
  content: '""',
  position: "absolute",
  top: "-px",
  right: "-px",
  bottom: "-px",
  left: "-px",
  bgImage: "linear-gradient(90deg, #8DE690 2.08%, #A5F0A3 18.23%, #A6ECD7 33.33%, #97DADA 51.56%, #B3DAE7 67.71%, #B6C9EC 83.33%, #879ACB 100%)",
  bgClip: "border-box"
}, Ce = {
  ..._e,
  _disabled: Pe,
  _focusVisible: St
}, Tt = q({
  variants: {
    just: {
      field: {
        ...Ce
      }
    },
    justUnstyled: {
      field: {
        ...Ce,
        _focusVisible: {
          boxShadow: "transprarent !important",
          bgGradient: "transprarent !important",
          bg: "#FFF !important"
        },
        _invalid: {
          boxShadow: "#FFF !important",
          bgGradient: "#FFF !important",
          bg: "#FFF !important"
        },
        border: "#FFF !important",
        bgGradient: "#FFF !important",
        bg: "#FFF !important"
      }
    }
  },
  // The default variant value
  defaultProps: {
    variant: "just"
  }
}), Re = ge(
  ({
    label: t,
    helper: n,
    error: r,
    isInvalid: o,
    isDisabled: i,
    isRequired: l = !0,
    value: c,
    onChange: d,
    onFocus: p,
    onBlur: g,
    Icon: s,
    variantError: D,
    ...y
  }, N) => {
    const [h, m] = x(!1);
    return /* @__PURE__ */ a(
      se,
      {
        variant: "floatingWithIcon",
        isRequired: l,
        isInvalid: !!o,
        isDisabled: !!i,
        width: "full",
        children: [
          /* @__PURE__ */ e(I, { _before: h && !o ? he : {}, children: /* @__PURE__ */ e(
            I,
            {
              ...re,
              ...ne,
              ...i ? le : {},
              ...!c && !h ? ie : {},
              ...r || o ? oe : {},
              children: /* @__PURE__ */ a(
                V,
                {
                  alignItems: "center",
                  justifyContent: "space-between",
                  alignContent: "center",
                  alignSelf: "center",
                  children: [
                    /* @__PURE__ */ a(Fe, { boxSize: "2rem", display: "flex", mt: 3, ml: 2, children: [
                      /* @__PURE__ */ e(
                        H,
                        {
                          src: !r && !i && h ? At : r && !i ? Ct : wt,
                          alt: "Aurora Ellipse",
                          position: "absolute",
                          top: "0",
                          left: "0",
                          boxSize: "2rem"
                        }
                      ),
                      /* @__PURE__ */ e(
                        s,
                        {
                          fill: c && !r && !i && h || !c && !r && h ? "#63DD51" : c && !r && !i ? "#1C1C1C" : r && !i ? "#EE5829" : "#8F8F8F"
                        }
                      )
                    ] }),
                    /* @__PURE__ */ a(V, { children: [
                      /* @__PURE__ */ e(
                        De,
                        {
                          zIndex: "10",
                          w: "full",
                          variant: "just",
                          placeholder: " ",
                          pl: 12,
                          pt: 3,
                          fontSize: "md",
                          textAlign: "left",
                          errorBorderColor: "danger.main",
                          ...J,
                          ...i ? X : {},
                          ...c ? {} : K,
                          ...r || o ? U : {},
                          borderColor: "transparent",
                          pr: 12,
                          value: c,
                          onChange: d,
                          onFocus: (M) => {
                            m(!0), p == null || p(M);
                          },
                          onBlur: (M) => {
                            m(!1), g == null || g(M);
                          },
                          ref: N,
                          ...y
                        }
                      ),
                      t && /* @__PURE__ */ e(
                        fe,
                        {
                          requiredIndicator: /* @__PURE__ */ e("abbr", { children: " *" }),
                          fontSize: "sm",
                          fontWeight: "medium",
                          px: "2px",
                          bg: "transparent",
                          style: {
                            backgroundColor: "transparent",
                            zIndex: "20"
                          },
                          children: t
                        }
                      )
                    ] })
                  ]
                }
              )
            }
          ) }),
          n && /* @__PURE__ */ e(Le, { pl: "4", fontSize: "xs", children: n }),
          r && /* @__PURE__ */ e(
            de,
            {
              fontSize: "0.625rem",
              fontWeight: "medium",
              zIndex: "5",
              sx: D === "discount" ? {
                position: "relative",
                color: "#FFF",
                bg: "danger.main",
                borderRadius: "1.875rem",
                padding: "0.375rem 0.375rem 0.375rem 0.75rem",
                alignItems: "center",
                gap: "1",
                width: "100%"
              } : {
                position: "absolute",
                color: "danger.main",
                bg: "#FFF",
                bottom: "-2",
                right: "5",
                px: "1",
                mb: "0.5"
              },
              children: r
            }
          )
        ]
      }
    );
  }
), Dr = ({ name: t, control: n, onChange: r, ...o }) => /* @__PURE__ */ e(
  He,
  {
    control: n,
    name: t,
    render: ({ field: i }) => /* @__PURE__ */ e(
      Re,
      {
        ...o,
        ...i,
        value: i.value ?? "",
        onChange: (l) => {
          i.onChange(l), r == null || r(l);
        }
      }
    )
  }
), Et = ({
  discount: t,
  onDiscountRemove: n,
  currency: r
}) => {
  var c;
  const [o, i] = x(!1), l = w(async () => {
    t.code && (i(!0), await n(t.code), i(!1));
  }, []);
  return /* @__PURE__ */ a(C, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ a(
      L,
      {
        backgroundColor: "brand.green",
        opacity: o ? 0.5 : 1,
        borderRadius: "base",
        spacing: 1,
        display: "flex",
        pt: 1.5,
        pr: 1.5,
        pb: 1.5,
        pl: 3,
        alignItems: "center",
        gap: 1,
        children: [
          /* @__PURE__ */ e(H, { width: "0.75rem", height: "0.75rem", src: zt, alt: "tag", loading: "lazy" }),
          /* @__PURE__ */ e(u, { color: "#1C1C1C", fontSize: "sm", fontWeight: "bold", lineHeight: "5", children: (c = t.code) == null ? void 0 : c.toUpperCase() }),
          /* @__PURE__ */ e(ke, { "aria-label": "Delete", variant: "unstyled", size: "xs", onClick: l, icon: /* @__PURE__ */ e(ue, {}) })
        ]
      }
    ),
    !!t.amount && /* @__PURE__ */ e(u, { fontSize: "sm", color: "#585858", fontWeight: "normal", children: ce(t.amount, { currency: r }) }),
    t.title && /* @__PURE__ */ e(u, { lineHeight: "5", color: "#585858", textAlign: "right", fontSize: "sm", children: t.title })
  ] });
}, Ft = ({
  discountApplyLabel: t,
  discountInputLabel: n,
  isDiscountDisabled: r = !1,
  onDiscountAddClick: o,
  discountErrorLabel: i,
  onDiscountRemove: l,
  discounts: c,
  currency: d,
  shouldFocusField: p,
  Icon: g
}) => {
  const [s, D] = x(""), y = Y(null), [N, h] = x(!1), m = async () => {
    h(!0);
    try {
      await o(y.current.value), y.current.value = "";
    } finally {
      h(!1);
    }
  };
  return E(() => {
    var M;
    p && ((M = y.current) == null || M.focus());
  }, [p]), /* @__PURE__ */ a(ee, { children: [
    /* @__PURE__ */ a(V, { size: "md", display: "flex", flexDirection: "row", alignItems: "flexStart", justifyContent: "center", children: [
      /* @__PURE__ */ e(
        Re,
        {
          autoComplete: "text",
          ref: y,
          error: i,
          isInvalid: !!i,
          isDisabled: r,
          label: n,
          isRequired: !1,
          flex: "1 0 0",
          h: "14",
          value: s,
          variantError: "discount",
          onChange: (M) => D(M.currentTarget.value),
          gap: 4,
          Icon: g
        }
      ),
      /* @__PURE__ */ e(
        We,
        {
          size: "sm",
          type: "submit",
          isLoading: N,
          isDisabled: (s == null ? void 0 : s.length) === 0,
          width: "6rem",
          h: "14",
          label: t,
          display: "flex",
          py: 4,
          px: 3,
          justifyContent: "center",
          alignItems: "center",
          gap: 2,
          ml: 1.5,
          onClick: m
        }
      )
    ] }),
    /* @__PURE__ */ e(O, { pt: 2, children: c != null && c.length ? c.map((M) => /* @__PURE__ */ e(
      Et,
      {
        discount: M,
        onDiscountRemove: l,
        currency: d
      },
      M.id
    )) : null })
  ] });
}, Se = 1, Te = 99, Lt = 700, kt = ({
  id: t,
  productId: n,
  variantId: r,
  defaultQuantity: o,
  customizationId: i,
  updateQuantity: l
}) => {
  const [c, d] = x(o), p = Qe(async (s) => {
    try {
      await l(s);
    } catch {
      d(o);
    }
  }, Lt);
  E(() => {
    d(o);
  }, [o]);
  const g = w(
    async (s) => {
      d(s), await p({ newQuantity: s, id: t, productId: n, variantId: r, customizationId: i });
    },
    [p, d]
  );
  return /* @__PURE__ */ a(
    L,
    {
      width: "auto",
      height: "1.75rem",
      justifyContent: "space-between",
      alignItems: "center",
      borderRadius: "lg",
      border: "1px solid #E0E0E0",
      background: "#FFF",
      boxShadow: "0px 1px 1px 0px rgba(0, 0, 0, 0.06)",
      children: [
        /* @__PURE__ */ e(
          Z,
          {
            onClick: () => c > Se && g(c - 1),
            variant: "ghost",
            h: "full",
            color: "gray.701",
            paddingInlineStart: 2,
            paddingInlineEnd: 2,
            minW: 8,
            roundedLeft: "lg",
            roundedRight: "none",
            "flex-shrink": "0",
            isDisabled: c === Se,
            children: "-"
          }
        ),
        /* @__PURE__ */ e(u, { color: "#585858", textAlign: "right", fontSize: "sm", lineHeight: "shorter", children: c }),
        /* @__PURE__ */ e(
          Z,
          {
            onClick: () => c < Te && g(c + 1),
            variant: "ghost",
            h: "full",
            minW: 8,
            color: "gray.701",
            paddingInlineStart: 2,
            paddingInlineEnd: 2,
            roundedRight: "lg",
            "flex-shrink": "0",
            roundedLeft: "none",
            isDisabled: c === Te,
            children: "+"
          }
        )
      ]
    }
  );
}, Ee = "https://via.placeholder.com/150?text=", vt = ({
  currency: t,
  customAttributes: n,
  customizationId: r,
  deleteLabel: o,
  discountAmount: i,
  id: l,
  imageUrl: c,
  isQuantityDisabled: d,
  isUpsellDisabled: p,
  leftQuantityTitle: g,
  name: s,
  onDelete: D,
  productId: y,
  quantity: N,
  quantityAvailable: h,
  totalAmount: m,
  updateQuantity: M,
  variant: S,
  variantId: T = void 0
}) => {
  const [Q, z] = x(!1), [B, F] = x(c), W = w(async () => {
    z(!0), await (D == null ? void 0 : D({ id: l, variantId: T })), z(!1);
  }, [D, z]), b = P(() => (16 * 0.39 - 0.12) * s.length > 178 ? "xs" : "md", [s]);
  return /* @__PURE__ */ a(
    L,
    {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      opacity: Q ? 0.4 : 1,
      spacing: 0.5,
      children: [
        /* @__PURE__ */ a(C, { py: 1, px: 0, "justify-content": "space-between", "align-items": "flex-start", gap: 4, flexShrink: "0", children: [
          /* @__PURE__ */ e(
            H,
            {
              boxSize: "4.5rem",
              flexShrink: "0",
              objectFit: "cover",
              borderRadius: "md",
              background: "lightgray 50% / cover no-repeat",
              src: B ?? Ee,
              alt: s,
              onError: () => {
                F(Ee);
              },
              loading: "lazy"
            }
          ),
          /* @__PURE__ */ a(te, { align: "start", spacing: 0.5, overflowY: "auto", children: [
            /* @__PURE__ */ e(u, { fontWeight: "medium", fontSize: b, lineHeight: "6", color: "#585858", maxW: "3xs", children: s }),
            /* @__PURE__ */ a(L, { flex: 1, children: [
              S != null && S.length ? /* @__PURE__ */ e(L, { spacing: 1, children: S.map((A, k) => /* @__PURE__ */ a(L, { spacing: 1, children: [
                /* @__PURE__ */ e(
                  u,
                  {
                    color: "#585858",
                    textAlign: "center",
                    fontSize: "sm",
                    fontWeight: "medium",
                    lineHeight: "shorter",
                    children: A
                  }
                ),
                k < S.length - 1 && /* @__PURE__ */ e($, { orientation: "vertical", h: 2 })
              ] }, A)) }) : null,
              h && h > 0 && h < 11 && /* @__PURE__ */ e(u, { color: "#8F8F8F", textAlign: "center", fontSize: "sm", fontWeight: "medium", lineHeight: "shorter", children: `${h} ${g}` })
            ] }),
            /* @__PURE__ */ a(L, { flex: 1, spacing: 1, children: [
              /* @__PURE__ */ e(
                u,
                {
                  color: "#8F8F8F",
                  lineHeight: "6",
                  textDecorationLine: i !== 0 ? "line-through" : "",
                  children: ce(m, { currency: t ?? "EUR" })
                }
              ),
              i !== 0 && /* @__PURE__ */ e(u, { color: "#C74931", lineHeight: "6", children: ce(
                Nt(m).subtract(
                  i ? i.toString().replace(",", ".") : "0"
                ).value,
                { currency: t ?? "EUR" }
              ) })
            ] }),
            D && !p ? /* @__PURE__ */ e(
              Z,
              {
                leftIcon: /* @__PURE__ */ e(Dt, {}),
                variant: "unstyled",
                color: "gray.603",
                size: "xs",
                textAlign: "left",
                onClick: () => W(),
                children: o
              }
            ) : null
          ] })
        ] }),
        /* @__PURE__ */ a(I, { justifyContent: "end", children: [
          n != null && n.length ? n == null ? void 0 : n.map((A) => /* @__PURE__ */ a(u, { fontWeight: "normal", color: "#8F8F8F", fontSize: "sm", lineHeight: "shorter", children: [
            A.key,
            " - ",
            A.value
          ] }, A.key)) : null,
          /* @__PURE__ */ e(L, { children: d ? void 0 : /* @__PURE__ */ e(
            kt,
            {
              id: l,
              variantId: T,
              defaultQuantity: N,
              customizationId: r,
              productId: y,
              updateQuantity: M
            }
          ) })
        ] })
      ]
    }
  );
}, Ot = ({
  totalDiscount: t,
  subTotal: n,
  shipping: r,
  tax: o,
  giftWrapping: i,
  totalGiftCard: l
}) => /* @__PURE__ */ a(ee, { children: [
  /* @__PURE__ */ a(C, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ e(u, { fontWeight: "normal", lineHeight: "6", color: "#8F8F8F", children: n.label }),
    /* @__PURE__ */ e(u, { lineHeight: "6", color: "#8F8F8F", children: n.value })
  ] }),
  r != null && r.value ? /* @__PURE__ */ a(C, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ e(u, { lineHeight: "6", color: "#8F8F8F", children: r.label }),
    /* @__PURE__ */ e(u, { lineHeight: "6", color: "#8F8F8F", children: r.value })
  ] }) : null,
  t != null && t.value ? /* @__PURE__ */ a(C, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ e(u, { lineHeight: "6", color: "#C74931", children: t.label }),
    /* @__PURE__ */ a(u, { lineHeight: "6", color: "#C74931", children: [
      "-",
      t.value
    ] })
  ] }) : null,
  i != null && i.value ? /* @__PURE__ */ a(C, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ e(u, { lineHeight: "6", color: "#8F8F8F", children: i.label ?? "" }),
    /* @__PURE__ */ a(u, { lineHeight: "6", color: "#8F8F8F", children: [
      "-",
      i.value
    ] })
  ] }) : null,
  o != null && o.value ? /* @__PURE__ */ a(C, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ e(u, { lineHeight: "6", color: "#8F8F8F", children: o.label }),
    /* @__PURE__ */ e(u, { lineHeight: "6", color: "#8F8F8F", children: o.value })
  ] }) : null,
  l != null && l.value ? /* @__PURE__ */ a(C, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ e(u, { fontWeight: "400", lineHeight: "6", color: "#8F8F8F", children: l.label }),
    /* @__PURE__ */ a(u, { fontWeight: "400", lineHeight: "6", color: "#8F8F8F", children: [
      "-",
      l.value
    ] })
  ] }) : null
] }), Ut = ({ label: t, value: n, taxIncludedTitle: r }) => /* @__PURE__ */ a(I, { children: [
  /* @__PURE__ */ a(C, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ e(u, { color: "#1C1C1C", fontSize: "lg", fontWeight: "semibold", lineHeight: "6", letterSpacing: "tight", children: t }),
    /* @__PURE__ */ e(u, { color: "#1C1C1C", fontSize: "lg", fontWeight: "semibold", lineHeight: "6", letterSpacing: "tight", children: n })
  ] }),
  /* @__PURE__ */ e(C, { justifyContent: "space-between", alignItems: "center", children: /* @__PURE__ */ e(u, { color: "#8F8F8F", fontSize: "0.625rem", letterSpacing: "tight", children: `(${r})` }) })
] }), Yt = ({ item: t, onClick: n }) => {
  const [r, o] = x(!1), i = w(async () => {
    o(!0), await n(t), o(!1);
  }, [n, o]), l = t == null ? void 0 : t.unitAmount;
  return /* @__PURE__ */ e(I, { w: "full", mb: 2, children: /* @__PURE__ */ a(C, { display: "flex", alignItems: "center", children: [
    /* @__PURE__ */ e(C, { padding: "0px", position: "relative", width: 12, height: 12, rounded: "md", bgColor: "#F5F5F7", children: /* @__PURE__ */ e(
      H,
      {
        boxSize: "35px",
        bgColor: "#F5F5F7",
        margin: "auto",
        objectFit: "cover",
        src: (t == null ? void 0 : t.imageUrl) ?? "",
        alt: t.name,
        loading: "lazy"
      }
    ) }),
    /* @__PURE__ */ a(te, { align: "start", spacing: 1, ml: 4, children: [
      /* @__PURE__ */ e(u, { fontWeight: "400", fontSize: "1rem", children: t == null ? void 0 : t.name }),
      /* @__PURE__ */ e(u, { color: "#gray.801", fontSize: "1rem", fontWeight: "500", children: ce(l ?? 0, {
        currency: "EUR"
      }) })
    ] }),
    /* @__PURE__ */ e(Xe, {}),
    /* @__PURE__ */ e(
      ke,
      {
        variant: "outline",
        "aria-label": "Add to cart",
        isLoading: r,
        onClick: i,
        icon: /* @__PURE__ */ e(ft, {})
      }
    )
  ] }) });
}, Ht = ({ onClick: t, products: n, upsellLabel: r, displayLimit: o = 2 }) => {
  if (!n.length)
    return /* @__PURE__ */ e(ee, {});
  const i = P(() => {
    const l = [...n];
    return l.length = o, l;
  }, [n]);
  return /* @__PURE__ */ e(jt, { title: r, px: 0, pt: "0px", pb: "1", children: /* @__PURE__ */ e(te, { align: "start", w: "full", children: i == null ? void 0 : i.map((l) => /* @__PURE__ */ e(Yt, { item: l, onClick: t }, l.productId)) }) });
}, fr = ({
  products: t,
  currency: n,
  totalDiscount: r,
  giftWrapping: o,
  subTotal: i,
  shipping: l,
  total: c,
  tax: d,
  discountApplyLabel: p,
  discountInputLabel: g,
  totalGiftCard: s,
  isDiscountDisabled: D,
  isQuantityDisabled: y,
  onDiscountAddClick: N,
  onDiscountRemove: h,
  discountErrorLabel: m,
  discounts: M,
  isUpsellDisabled: S = !0,
  upsellLabel: T,
  upsellProducts: Q,
  onUpsellClick: z,
  onDeleteProduct: B,
  deleteLabel: F,
  shouldFocusDiscountField: W,
  updateQuantity: b,
  taxIncludedTitle: A,
  leftQuantityTitles: k,
  Icon: Ie,
  ...pe
}) => /* @__PURE__ */ a(O, { ...pe, children: [
  /* @__PURE__ */ e(O, { w: "full", spacing: 2, children: /* @__PURE__ */ e(
    Ot,
    {
      giftWrapping: o,
      tax: d,
      totalGiftCard: s,
      totalDiscount: r,
      subTotal: i,
      shipping: l
    }
  ) }),
  /* @__PURE__ */ e(Ut, { value: c.value, label: c.label, taxIncludedTitle: A }),
  /* @__PURE__ */ e(O, { spacing: 0, children: /* @__PURE__ */ e(
    Ft,
    {
      discountApplyLabel: p,
      discountInputLabel: g,
      discountErrorLabel: m,
      discounts: M,
      onDiscountAddClick: N,
      onDiscountRemove: h,
      isDiscountDisabled: !!D,
      shouldFocusField: !!W,
      currency: n,
      Icon: Ie
    }
  ) }),
  /* @__PURE__ */ e($, { variant: "dashed", py: 0 }),
  /* @__PURE__ */ a(I, { display: "flex", flexDirection: "column", children: [
    t.map((_, me) => /* @__PURE__ */ mt(
      vt,
      {
        ..._,
        currency: n,
        isUpsellDisabled: S,
        isQuantityDisabled: y,
        onDelete: B,
        deleteLabel: F ?? "",
        updateQuantity: b,
        discountAmount: _.discountAmount,
        key: _.productId,
        leftQuantityTitle: k[me] ?? "",
        quantityAvailable: _.quantityAvailable ?? 99
      }
    )),
    !S && /* @__PURE__ */ a(ee, { children: [
      /* @__PURE__ */ e(Ht, { upsellLabel: T, products: Q, onClick: z }),
      /* @__PURE__ */ e($, { variant: "dashed" })
    ] })
  ] })
] }), Ne = ge(
  ({
    label: t,
    helper: n,
    error: r,
    isInvalid: o,
    isDisabled: i,
    isRequired: l = !0,
    value: c,
    onChange: d,
    onFocus: p,
    variant: g,
    onBlur: s,
    ...D
  }, y) => {
    const [N, h] = x(!1);
    return /* @__PURE__ */ a(
      se,
      {
        variant: "floating",
        isRequired: l,
        isInvalid: !!o,
        isDisabled: !!i,
        width: "full",
        children: [
          /* @__PURE__ */ e(
            I,
            {
              _before: g !== "justUnstyled" && N && !o ? he : {},
              children: /* @__PURE__ */ e(
                I,
                {
                  ...g !== "justUnstyled" ? {
                    ...re,
                    ...ne,
                    ...i ? le : {},
                    ...!c && !N ? ie : {},
                    ...r || o ? oe : {}
                  } : {},
                  children: /* @__PURE__ */ a(V, { justifyContent: "center", alignItems: "center", alignContent: "center", alignSelf: "center", children: [
                    /* @__PURE__ */ e(
                      De,
                      {
                        w: "full",
                        variant: "just",
                        placeholder: " ",
                        height: 14,
                        fontSize: "md",
                        textAlign: "left",
                        borderLeftRadius: g === "justUnstyled" ? "0" : "",
                        borderRightRadius: g === "justUnstyled" ? "1.875rem" : "",
                        errorBorderColor: "danger.main",
                        ...J,
                        ...i ? X : {},
                        ...c ? {} : K,
                        ...r || o ? U : {},
                        borderColor: i ? "gray.602" : "transparent",
                        border: "",
                        pr: 12,
                        value: c,
                        onChange: d,
                        onFocus: (m) => {
                          h(!0), p == null || p(m);
                        },
                        onBlur: (m) => {
                          h(!1), s == null || s(m);
                        },
                        ...D,
                        ref: y
                      }
                    ),
                    t && /* @__PURE__ */ e(
                      fe,
                      {
                        requiredIndicator: /* @__PURE__ */ e("abbr", { children: " *" }),
                        fontSize: "sm",
                        fontWeight: "medium",
                        bg: "transparent",
                        style: {
                          backgroundColor: "transparent",
                          zIndex: "20"
                        },
                        children: t
                      }
                    )
                  ] })
                }
              )
            }
          ),
          n && /* @__PURE__ */ e(Le, { pl: "4", pb: "2", fontSize: "xs", children: n }),
          r && /* @__PURE__ */ e(
            de,
            {
              position: "absolute",
              fontSize: "0.625rem",
              fontWeight: "medium",
              color: "danger.main",
              bg: "#FFF",
              bottom: "-2",
              right: "5",
              px: "1",
              mb: "0.5",
              children: r
            }
          )
        ]
      }
    );
  }
), Nr = ({ name: t, control: n, onChange: r, ...o }) => /* @__PURE__ */ e(
  He,
  {
    control: n,
    name: t,
    render: ({ field: i }) => /* @__PURE__ */ e(
      Ne,
      {
        ...o,
        ...i,
        value: i.value ?? "",
        onChange: (l) => {
          i.onChange(l), r == null || r(l);
        }
      }
    )
  }
), Qt = ve`
  from { transform: rotate(0deg); }
  to { transform: rotate(180deg); }
`, Bt = ve`
  from { transform: rotate(180deg); }
  to { transform: rotate(0deg); }
`, br = ({
  inputProps: t,
  isSearchable: n,
  options: r,
  noResultLabel: o,
  onChange: i
}) => {
  const [l, c] = x(!1), [d, p] = x(null), [g, s] = x(null), D = w(() => {
    c(!l);
  }, [l, g]), y = w(
    (m) => {
      const M = m.target.value;
      p(M.trim() ? M : null), M.trim() || s(null);
    },
    [g]
  ), N = P(
    () => new bt(r, { isCaseSensitive: !1, keys: ["value"], threshold: 0.2 }),
    [r]
  ), h = P(() => n && d ? N.search(d).map((m) => m.item) : r, [d, n]);
  return /* @__PURE__ */ a(O, { children: [
    /* @__PURE__ */ a(V, { children: [
      /* @__PURE__ */ e(
        Ne,
        {
          onFocus: D,
          onBlur: D,
          ...t,
          error: l ? void 0 : t.error,
          value: d ?? (g == null ? void 0 : g.value),
          onChange: y,
          autoComplete: "tel",
          isRequired: t.isRequired ?? !1
        }
      ),
      /* @__PURE__ */ e(Ke, { height: "100%", children: !t.isInvalid && /* @__PURE__ */ e(
        Ue,
        {
          color: t.isDisabled ? "gray.100" : "inherit",
          transform: l ? "rotate(180deg)" : "rotate(0deg)",
          animation: l ? `${Qt} 0.2s linear` : `${Bt} 0.2s linear`,
          fontSize: "2xl"
        }
      ) })
    ] }),
    /* @__PURE__ */ e(I, { shadow: "base", borderRadius: "md", children: /* @__PURE__ */ e(qe, { in: l, animateOpacity: !0, unmountOnExit: !0, children: /* @__PURE__ */ e(O, { spacing: 2, borderRadius: "md", border: "1px solid", borderColor: "gray.100", children: h.length ? h == null ? void 0 : h.map((m, M) => /* @__PURE__ */ a(
      L,
      {
        onClick: () => {
          p(null), i == null || i(m.value), s(m);
        },
        cursor: "pointer",
        spacing: "2",
        display: "flex",
        alignItems: "center",
        borderTopLeftRadius: M === 0 ? "md" : "",
        borderTopRightRadius: M === 0 ? "md" : "",
        borderBottomLeftRadius: M === h.length - 1 ? "md" : "",
        borderBottomRightRadius: M === h.length - 1 ? "md" : "",
        p: "4",
        _hover: {
          backgroundColor: "gray.50"
        },
        children: [
          m.icon ? m.icon : null,
          /* @__PURE__ */ e(u, { fontSize: "1rem", fontWeight: "medium", children: m == null ? void 0 : m.value })
        ]
      },
      m.value
    )) : /* @__PURE__ */ e(I, { p: "4", borderRadius: "md", border: "1px solid", borderColor: "gray.100", children: /* @__PURE__ */ e(u, { textAlign: "center", children: o }) }) }) }) })
  ] });
}, xr = ({ title: t, showBackIcon: n, showCloseIcon: r, children: o, ...i }) => /* @__PURE__ */ a(et, { autoFocus: !1, placement: "bottom", blockScrollOnMount: !0, ...i, children: [
  /* @__PURE__ */ e(tt, {}),
  /* @__PURE__ */ a(rt, { borderTopRadius: i.isFullHeight ? "none" : "2xl", children: [
    /* @__PURE__ */ a(
      nt,
      {
        onClick: i.onClose,
        cursor: "pointer",
        textAlign: "center",
        fontWeight: "500",
        lineHeight: "24px",
        fontSize: "1rem",
        position: "relative",
        borderBottom: "1px solid",
        borderColor: "gray.602",
        mb: 2,
        children: [
          n && /* @__PURE__ */ e(Ye, { left: "15px", position: "absolute", fontSize: "2xl" }),
          t,
          r && /* @__PURE__ */ e(ue, { right: "25px", position: "absolute", top: "22px", fontSize: "sm" })
        ]
      }
    ),
    o
  ] })
] });
const Ge = (t, n) => {
  const [r, o] = x(!1);
  return E(() => {
    let i;
    return t && !r ? o(!0) : !t && r && (i = setTimeout(() => o(!1), n)), () => {
      clearTimeout(i);
    };
  }, [n, t, r]), r;
};
function Wt() {
  const t = document.createElement("div");
  return t.setAttribute("id", "superdrawer-root"), t;
}
const jr = () => {
  const [t, n] = x(!1), r = w(() => {
    n(!t);
  }, [t]);
  return { isOpen: t, onToggle: r };
}, zr = ({
  children: t,
  onClose: n,
  isOpen: r,
  position: o = "bottom",
  title: i,
  removeWhenClosed: l = !0,
  isFullHeight: c = !1,
  size: d = "unset",
  showBackIcon: p = !1,
  showCloseIcon: g = !1,
  containerRef: s,
  overlayColor: D = ""
}) => {
  const y = Y();
  E(() => {
    y.current = document.getElementById("superdrawer-root") ?? Wt();
  }, []);
  const N = Ge(r, 300);
  E(() => {
    (() => {
      s != null && s.current && (r ? s.current.style.overflow = "hidden" : s.current.style.overflow = "");
    })();
  }, [s, r]);
  const h = w(
    (M) => {
      M.key === "Escape" && r && n();
    },
    [n]
  ), m = w(
    (M) => {
      M.target instanceof HTMLElement && M.target.classList.contains("superdrawer-overlay-wrapper") && n();
    },
    [n]
  );
  return E(() => (document.addEventListener("keydown", h, !1), () => document.removeEventListener("keydown", h, !1)), [h]), E(() => {
    if (!(s != null && s.current) || !(y != null && y.current))
      return;
    s.current.appendChild(y.current);
    const M = s.current;
    return () => {
      M.style.overflow = "";
    };
  }, [s]), !N && l && !r || !y.current ? null : Be(
    /* @__PURE__ */ e(
      "div",
      {
        "aria-hidden": r ? "false" : "true",
        className: `superdrawer-container ${r ? "open" : ""} ${N ? "in" : ""}`,
        children: /* @__PURE__ */ e(I, { className: "superdrawer-overlay-wrapper", bg: D, onClick: m, children: /* @__PURE__ */ a(
          I,
          {
            roundedTop: c ? "none" : "3xl",
            boxShadow: "0px -2px 12px 0px rgba(0, 0, 0, 0.08)",
            className: `superdrawer ${o}`,
            role: "dialog",
            height: c ? "full" : d,
            pt: "60px",
            children: [
              /* @__PURE__ */ a(
                I,
                {
                  onClick: n,
                  cursor: "pointer",
                  textAlign: "center",
                  fontWeight: "500",
                  lineHeight: "24px",
                  fontSize: "1rem",
                  position: "absolute",
                  top: "0",
                  w: "full",
                  zIndex: 1001,
                  backgroundColor: "white",
                  borderBottom: "1px solid",
                  borderColor: "gray.602",
                  mb: 2,
                  p: 4,
                  children: [
                    p && /* @__PURE__ */ e(Ye, { left: "15px", position: "absolute", fontSize: "2xl" }),
                    i,
                    g && /* @__PURE__ */ e(ue, { right: "25px", position: "absolute", top: "22px", fontSize: "sm" })
                  ]
                }
              ),
              /* @__PURE__ */ e(I, { py: 2, px: 6, overflowY: "scroll", h: "full", children: t })
            ]
          }
        ) })
      }
    ),
    y.current
  );
}, Ar = ({ isDisabled: t, children: n, ...r }) => /* @__PURE__ */ e(ye, { cursor: "pointer", size: "lg", colorScheme: "fullBlack", isDisabled: !!t, ...r, children: n }), _t = ({
  value: t,
  onChange: n,
  iconComponent: r,
  options: o,
  ...i
}) => /* @__PURE__ */ a(I, { position: "relative", width: 24, className: "countrySelect", children: [
  /* @__PURE__ */ e(I, { display: "flex", alignItems: "center", height: "100%", ml: 4, children: /* @__PURE__ */ e(r, { country: t ?? "", label: t ?? "" }) }),
  /* @__PURE__ */ e(
    ot,
    {
      variant: "unstyled",
      position: "absolute",
      p: 0,
      top: 0,
      right: "0",
      display: "block",
      zIndex: 1,
      opacity: 0,
      _disabled: { opacity: 0, cursor: "not-allowed" },
      cursor: "pointer",
      value: t,
      mt: 4,
      onChange: (l) => n(l.target.value || void 0),
      "aria-label": "Phone number country",
      ...i,
      children: o.map(({ label: l, value: c }) => /* @__PURE__ */ e("option", { value: c, children: l }, c ?? "ZZ"))
    }
  )
] }), Pt = {
  borderColor: "danger.main !important",
  background: "#FFF"
}, Rt = {
  // apply Input Theme style
  ".isDisabled": {
    borderColor: "gray.602",
    bg: "#FFF !important",
    color: "gray.603 !important"
  },
  ".isInvalid": Pt,
  ".PhoneInput:hover:not(.isDisabled) .countrySelect": {
    borderTop: 0,
    borderBottom: 0,
    borderLeft: 0
  },
  ".chakra-select__wrapper": {
    top: "-3px"
  }
}, wr = ge(
  ({ label: t, error: n, value: r, onChange: o, onFocus: i, defaultCountry: l, isRequired: c = !1, ...d }, p) => {
    const g = (y) => {
      o == null || o(y);
    }, [s, D] = x(!1);
    return /* @__PURE__ */ a(I, { position: "relative", children: [
      /* @__PURE__ */ e(I, { _before: { ...s ? he : {} }, children: /* @__PURE__ */ e(
        I,
        {
          ...re,
          ...ne,
          ...d.isDisabled ? le : {},
          ...!r && !s ? ie : {},
          ...n ? oe : {},
          children: /* @__PURE__ */ e(I, { bg: "#FFF", borderRadius: "1.875rem", children: /* @__PURE__ */ e(
            I,
            {
              __css: {
                ...Rt,
                ".PhoneInput": {
                  borderRadius: "1.875rem",
                  ...J,
                  ...d.isDisabled ? X : {},
                  ...!r && !s ? K : {},
                  ...n ? U : {},
                  ...s ? U : {}
                },
                // custom flag icon
                ".PhoneInputCountryIcon--border": {
                  ...J,
                  ...d.isDisabled ? X : {},
                  ...!r && !s ? K : {},
                  ...n ? U : {},
                  ...s ? U : {},
                  justifyContent: "center",
                  alignItems: "center",
                  boxShadow: "none",
                  borderRadius: "2px",
                  overflow: "hidden",
                  zIndex: "1000"
                },
                // custom country select
                ".PhoneInput .countrySelect": {
                  borderLeftRadius: "1.875rem",
                  background: s ? "#FFF" : ""
                }
              },
              children: /* @__PURE__ */ e(
                xt,
                {
                  className: `${d.isInvalid ? "isInvalid" : ""} ${d.isDisabled ? "isDisabled" : ""}`,
                  style: {
                    alignItems: "stretch",
                    backgound: n || d.isInvalid ? "danger.main !important" : d.isDisabled || !r ? "gray.602 !important" : ""
                  },
                  defaultCountry: l ?? "FR",
                  value: r ?? "",
                  ref: p ?? void 0,
                  onChange: g,
                  onFocus: (y) => {
                    D(!0), i == null || i(y);
                  },
                  onBlur: () => {
                    D(!1);
                  },
                  label: t,
                  isRequired: c,
                  variant: "justUnstyled",
                  inputComponent: Ne,
                  disabled: !!d.isDisabled,
                  countrySelectComponent: _t,
                  ...d
                }
              )
            }
          ) })
        }
      ) }),
      n && /* @__PURE__ */ e(se, { isInvalid: !!d.isInvalid, children: /* @__PURE__ */ e(
        de,
        {
          position: "absolute",
          fontSize: "0.625rem",
          fontWeight: "350",
          color: "danger.main",
          bg: "#FFF",
          bottom: "-2",
          right: "5",
          px: "1",
          mb: "0.5",
          zIndex: "5",
          children: n
        }
      ) })
    ] });
  }
), Gt = q({
  // The styles all Box have in common
  baseStyle: {
    display: "flex",
    alignItems: "center",
    fontFamily: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    _disabled: {
      backgroundColor: "gray.601",
      color: "#8F8F8F"
    },
    fontWeight: "semibold",
    lineHeight: "6",
    fontSize: "lg",
    letterSpacing: "tighter",
    fontStyle: "normal",
    color: "black.900"
  },
  // The default variant value
  defaultProps: {
    variant: "primary"
  }
}), Zt = q({
  // The styles all Buttons have in common
  baseStyle: {
    display: "flex",
    alignItems: "center",
    fontFamily: `'Beausite classic', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    _disabled: {
      backgroundColor: "gray.601",
      color: "#8F8F8F"
    },
    fontWeight: "semibold",
    lineHeight: "6",
    fontSize: "lg",
    letterSpacing: "tighter",
    fontStyle: "normal",
    borderRadius: "6rem"
  },
  variants: {
    primary: {
      color: "white",
      backgroundColor: "buttonBlack.900",
      _hover: {
        backgroundColor: "buttonBlack.500"
      },
      _active: {
        backgroundColor: "buttonBlack.900"
      },
      _loading: {
        backgroundColor: "buttonBlack.900 !important",
        fontSize: "1.5rem",
        color: "white"
      }
    },
    secondary: {
      color: "gray.701",
      backgroundColor: "gray.602",
      _hover: {
        backgroundColor: "gray.602"
      },
      _active: {
        backgroundColor: "gray.602"
      },
      _loading: {
        backgroundColor: "gray.601 !important",
        color: "gray.701"
      }
    },
    disabled: {
      color: "gray.701",
      backgroundColor: "gray.601",
      _hover: {
        backgroundColor: "gray.601"
      },
      _active: {
        backgroundColor: "gray.601"
      },
      _loading: {
        backgroundColor: "gray.601 !important",
        color: "gray.701"
      }
    }
  },
  // The default variant value
  defaultProps: {
    variant: "primary"
  }
}), be = {
  // The styles all Checkbox have in common
  baseStyle: {
    display: "flex",
    alignItems: "center",
    fontFamily: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    color: "#8F8F8F",
    fontWeight: "semibold",
    lineHeight: "5",
    fontSize: "sm",
    _disabled: {
      bg: "gray.600",
      color: "#8F8F8F"
    },
    control: {
      _checked: {
        bg: "#1C1C1C",
        borderColor: "#1C1C1C"
      },
      borderRadius: "4px",
      h: "20px",
      w: "20px"
    }
  },
  defaultProps: {
    variant: "black"
  }
};
Oe({
  components: {
    Checkbox: be
  }
});
const Vt = it({
  borderWidth: "1px",
  borderStyle: "dashed"
}), $t = q({
  variants: { dashed: Vt }
}), R = {
  transform: "scale(0.75) translateY(-0.5rem)",
  fontSize: "0.625rem"
}, Jt = q({
  variants: {
    floating: {
      //@ts-expect-error ts error
      container: {
        color: "gray.603",
        _hover: {
          label: {
            color: "gray.603"
          }
        },
        _focusWithin: {
          label: {
            ...R
          }
        },
        "input:not(:placeholder-shown):not(:focus-visible) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown):not(:focus-visible) ~ label": {
          ...R,
          display: "flex"
        },
        label: {
          _disabled: {
            color: "gray.603"
          },
          textAlign: "left",
          top: 4,
          left: 4,
          whiteSpace: "nowrap",
          color: "inherit !important",
          zIndex: 2,
          position: "absolute",
          backgroundColor: "white",
          pointerEvents: "none",
          my: 0,
          transformOrigin: "left top",
          fontsize: "xs",
          fontWeight: "medium"
        }
      }
    },
    floatingWithIcon: {
      //@ts-expect-error ts error
      container: {
        color: "gray.603",
        _hover: {
          label: {
            color: "gray.603"
          }
        },
        _focusWithin: {
          label: {
            ...R
          }
        },
        "input:not(:placeholder-shown):not(:focus-visible) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown):not(:focus-visible) ~ label": {
          ...R,
          display: "flex"
        },
        label: {
          _disabled: {
            color: "gray.603"
          },
          textAlign: "left",
          top: 4,
          left: 12,
          whiteSpace: "nowrap",
          color: "inherit !important",
          zIndex: 2,
          position: "absolute",
          backgroundColor: "white",
          pointerEvents: "none",
          my: 0,
          transformOrigin: "left top",
          fontWeight: "medium",
          fontsize: "xs"
        }
      }
    },
    mobileSelect: {
      //@ts-expect-error ts error
      container: {
        color: "gray.603",
        _hover: {
          label: {
            color: "gray.603"
          }
        },
        _focusWithin: {
          label: {
            ...R
          }
        },
        "input:not(:placeholder-shown):not(:focus-visible) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown):not(:focus-visible) ~ label": {
          ...R,
          display: "flex"
        },
        label: {
          transform: "scale(0.75) translateY(-0.5rem)",
          fontSize: "0.625rem",
          _disabled: {
            color: "gray.603"
          },
          textAlign: "left",
          top: 4,
          left: 4,
          whiteSpace: "nowrap",
          color: "inherit !important",
          zIndex: 2,
          position: "absolute",
          backgroundColor: "white",
          pointerEvents: "none",
          my: 0,
          transformOrigin: "left top",
          fontWeight: "medium"
        }
      }
    }
  },
  defaultProps: {
    variant: "floating"
  }
}), Xt = q({
  sizes: {
    lg: {
      control: { w: "5", h: "5" },
      label: { fontSize: "md", width: "full" }
    }
  }
}), G = Oe({
  fonts: {
    heading: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    body: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    span: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    p: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`
  },
  shadows: {
    just: "0px 6px 10px rgba(0, 0, 0, 0.08), 0px 1px 18px rgba(0, 0, 0, 0.06), 0px 3px 5px rgba(0, 0, 0, 0.1)"
  },
  components: {
    Button: Zt,
    Divider: $t,
    Form: Jt,
    Input: Tt,
    Radio: Xt,
    Box: Gt,
    CheckBox: be
  },
  themedClasses: {
    inputBackgroundDisabledStyle: X,
    inputBackgroundEmptyStyle: K,
    inputBackgroundGradientStyle: J,
    inputBackgroundInvalidStyle: U,
    inputBorderDisabledStyle: le,
    inputBorderEmptyStyle: ie,
    inputBorderGradientStyle: ne,
    inputBorderInvalidStyle: oe,
    inputBorderStyle: re,
    inputBoxShadowGradientStyle: he
  },
  colors: {
    brand: {
      yellow: "#FFA908",
      green: "#A1FB86",
      fushia: "#EDBFFB"
    },
    fullBlack: {
      50: "#282525",
      500: "#262323",
      900: "#1C1C1C"
    },
    buttonBlack: {
      50: "#8F8F8F",
      500: "#1C1C1C",
      900: "#050505"
    },
    yellowScheme: {
      50: "#FFD587",
      500: "#FFD587",
      900: "#FFA908"
    },
    gray: {
      601: "#F7F7F7",
      602: "#E0E0E0",
      603: "#8F8F8F",
      701: "#585858",
      801: "#1C1C1C"
    },
    danger: {
      main: "#EE5829",
      text: "#EE5829"
    },
    focus: {
      main: "#0F4C8F",
      error: "#E9553A"
    }
  }
}), Cr = ({
  placeholder: t,
  label: n,
  isDisabled: r,
  subtitle: o,
  onClick: i,
  reverse: l,
  isInvalid: c = !1,
  error: d,
  Icon: p
}) => /* @__PURE__ */ e(
  I,
  {
    ...re,
    ...n ? ne : {},
    ...r ? le : {},
    ...n ? {} : ie,
    ...d || c ? oe : {},
    onClick: () => !r && (i == null ? void 0 : i()),
    children: /* @__PURE__ */ a(
      I,
      {
        w: "full",
        height: 14,
        display: "flex",
        px: 4,
        py: 3,
        fontSize: "md",
        borderRadius: "1.875rem",
        cursor: r ? "not-allowed" : "pointer",
        ...J,
        ...r ? X : {},
        ...!n && !r ? K : {},
        ...d || c ? U : {},
        borderColor: r ? "gray.602" : "transparent",
        bgColor: "white",
        position: "relative",
        alignItems: "center",
        children: [
          /* @__PURE__ */ e(I, { ml: "-2", mr: "2", children: p && /* @__PURE__ */ e(p, { fill: n ? "#1C1C1C" : "#585858", alt: "placeholderDropdown icon" }) }),
          t && !n && /* @__PURE__ */ e(u, { fontSize: "sm", fontWeight: "350", color: "gray.603", children: t }),
          n && /* @__PURE__ */ a(C, { direction: l ? "column-reverse" : "column", children: [
            /* @__PURE__ */ e(u, { noOfLines: 1, fontSize: "sm", fontWeight: "350", lineHeight: "24px", color: "gray.603", children: n }),
            o && /* @__PURE__ */ e(u, { noOfLines: 1, fontSize: "12px", fontWeight: "350", lineHeight: "16px", color: "gray.603", children: o })
          ] })
        ]
      }
    )
  }
), Kt = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2IiBmaWxsPSJub25lIj4KICA8cGF0aCBkPSJNMyAxMS43NzcyVjEzLjYyOTVDMyAxMy44MDA1IDMuMTQyNDkgMTMuOTQzIDMuMzEzNDcgMTMuOTQzSDUuMTY1OEM1LjIyMjggMTMuOTQzIDUuMzA4MjkgMTMuOTE0NSA1LjM2NTI5IDEzLjg1NzVMMTIuMDA1MiA3LjIxNzYyTDkuNzI1MzkgNC45Mzc4MkwzLjA4NTQ5IDExLjU3NzdDMy4wMjg1IDExLjYzNDcgMyAxMS42OTE3IDMgMTEuNzc3MlpNMTMuNzcyIDQuNTk1ODVMMTIuMzQ3MiAzLjE3MDk4QzEyLjExOTIgMi45NDMwMSAxMS43MjAyIDIuOTQzMDEgMTEuNDkyMiAzLjE3MDk4TDEwLjM4MDggNC4yODIzOEwxMi42NjA2IDYuNTYyMThMMTMuNzcyIDUuNDUwNzhDMTQgNS4yMjI4IDE0IDQuODIzODMgMTMuNzcyIDQuNTk1ODVaIiBmaWxsPSIjOEY4RjhGIi8+Cjwvc3ZnPg==", Sr = ({
  placeholder: t,
  label: n,
  isDisabled: r,
  subtitle: o,
  onClick: i,
  reverse: l,
  Icon: c,
  cardBrand: d
}) => /* @__PURE__ */ a(
  Me,
  {
    onClick: () => !r && (i == null ? void 0 : i()),
    w: "full",
    height: 14,
    display: "flex",
    px: 4,
    py: 3,
    fontSize: "md",
    borderRadius: "0.875rem",
    cursor: r ? "not-allowed" : "pointer",
    position: "relative",
    alignItems: "center",
    variant: "gradient",
    children: [
      d && c && /* @__PURE__ */ a(L, { spacing: "4", children: [
        /* @__PURE__ */ e(c, { brand: d }),
        /* @__PURE__ */ a(te, { align: "baseline", spacing: -4, children: [
          n && /* @__PURE__ */ e(u, { color: "#1C1C1C", fontSize: "md", fontStyle: "normal", fontWeight: "350", lineHeight: "6", children: n }),
          o && /* @__PURE__ */ e(u, { fontWeight: "medium", color: "#585858", fontSize: "xs", fontStyle: "normal", lineHeight: "4", children: o })
        ] }),
        /* @__PURE__ */ e(H, { src: Kt, alt: "edit icon", position: "absolute", right: "4" })
      ] }),
      t && !n && !d && !c && /* @__PURE__ */ e(u, { fontSize: "1rem", fontWeight: "350", color: "gray.603", children: t }),
      n && !d && !c && /* @__PURE__ */ a(C, { direction: l ? "column-reverse" : "column", children: [
        /* @__PURE__ */ e(
          u,
          {
            noOfLines: 1,
            fontSize: "1rem",
            fontWeight: "350",
            lineHeight: "24px",
            color: r ? "gray.300" : "#1C1C1C",
            children: n
          }
        ),
        o && /* @__PURE__ */ e(
          u,
          {
            noOfLines: 1,
            fontSize: "12px",
            fontWeight: "350",
            lineHeight: "16px",
            color: r ? "gray.300" : "gray.701",
            children: o
          }
        )
      ] })
    ]
  }
), Tr = ({ passwordSize: t, ...n }) => {
  const r = Y(null), [o, i] = x(0);
  E(() => {
    r.current && r.current.focus();
  }, []);
  const l = () => {
    r.current && o < 5 && r.current.focus();
  }, c = P(
    () => new Array(t).fill(1, 0, t).map((p, g) => g + 1),
    [t]
  );
  return /* @__PURE__ */ e(Me, { height: "3.5rem", variant: "gradient", ...{
    borderRadius: "1.875rem",
    justifyContent: "center",
    alignItems: "center",
    padding: "1rem 2rem",
    gap: "4"
  }, children: /* @__PURE__ */ e(lt, { size: "md", otp: !0, variant: "unstyled", placeholder: "✦", manageFocus: !0, ...n, children: c.map((p, g) => /* @__PURE__ */ e(
    at,
    {
      ref: (s) => {
        g === o && (r.current = s), g === o && r.current && r.current.value !== "" && o < 5 && i(o + 1);
      },
      onClick: l
    },
    g
  )) }) });
}, qt = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02LjU0MDkzIDAuMDA0NDQzODhDNi4wMzEzOCAwLjAyNjk1OTEgNS41ODMwNiAwLjA5MTY4ODcgNS4xMjY1MyAwLjIwODY2OEMzLjc2MjE3IDAuNTU4MjYxIDIuNTU3OTYgMS4zMDc1NyAxLjYzNTQ4IDIuMzgwOTRDMC43MjI1IDMuNDQzMjcgMC4xNTYwODcgNC43NzgyNSAwLjAyOTI5NjkgNi4xNjY1NEMtMC4wMDYzODk0OSA2LjU1NzMxIC0wLjAwODcyNTQ5IDYuOTkxNzIgMC4wMjI3ODE3IDcuMzc2MTRDMC4xMzI2NTcgOC43MTY1NyAwLjYzOTY5NyA5Ljk5Mzc3IDEuNDgxMTYgMTEuMDQ5N0MxLjc1MjI0IDExLjM4OTkgMi4wODA5MyAxMS43Mjc1IDIuNDI1NzYgMTIuMDJDMy4yMDA1NiAxMi42NzcgNC4xNTM0MSAxMy4xNjQyIDUuMTU1MzMgMTMuNDE1NUM2LjEyMzEzIDEzLjY1ODIgNy4xNjk0NiAxMy42ODIzIDguMTU1OCAxMy40ODQ2QzkuMTM5MzggMTMuMjg3NCAxMC4wODYyIDEyLjg2MyAxMC44OTA3IDEyLjI1ODdDMTAuOTQ4OCAxMi4yMTUxIDEwLjk5ODIgMTIuMTc5MyAxMS4wMDA1IDEyLjE3OTNDMTEuMDAyOSAxMi4xNzkzIDExLjgyNDEgMTIuOTk4MiAxMi44MjU2IDEzLjk5OTFDMTMuOTkyNSAxNS4xNjUyIDE0LjY2NjEgMTUuODMzOCAxNC43MDA5IDE1Ljg2MDVDMTQuNzY1OCAxNS45MTAzIDE0LjgzMzEgMTUuOTU0IDE0Ljg4NiAxNS45ODA3TDE0LjkyNDYgMTYuMDAwMUgxNS4xNzEzSDE1LjQxOEwxNS40NjMgMTUuOTc3NUMxNS42NjM1IDE1Ljg3NjYgMTUuODc2NSAxNS42NjM1IDE1Ljk3NzUgMTUuNDYzTDE2LjAwMDEgMTUuNDE4MVYxNS4xNzEzVjE0LjkyNDZMMTUuOTgwNyAxNC44ODZDMTUuOTU0IDE0LjgzMzEgMTUuOTEwMiAxNC43NjU4IDE1Ljg2MDUgMTQuNzAwOUMxNS44MzM4IDE0LjY2NjEgMTUuMTY1MiAxMy45OTI1IDEzLjk5OTEgMTIuODI1N0MxMi45OTgyIDExLjgyNDIgMTIuMTc5MyAxMS4wMDI5IDEyLjE3OTMgMTEuMDAwNkMxMi4xNzkzIDEwLjk5ODMgMTIuMjE1IDEwLjk0ODggMTIuMjU4NyAxMC44OTA3QzEyLjc2NzQgMTAuMjEzNSAxMy4xNTE2IDkuNDMwMDMgMTMuMzc2NSA4LjYxMTM0QzEzLjY2IDcuNTc4OTggMTMuNjkzNyA2LjQ1OTg3IDEzLjQ3MyA1LjQwNDk0QzEzLjI3ODUgNC40NzUzIDEyLjg3MjEgMy41NjIzOSAxMi4zMTI3IDIuNzk5QzEyLjA5MDcgMi40OTU5OCAxMS44OTYxIDIuMjY5ODcgMTEuNjE5NyAxLjk5MzQ4QzExLjQwNTYgMS43Nzk1MyAxMS4yNjExIDEuNjQ5NiAxMS4wNDk3IDEuNDgxMThDMTAuMzUzMyAwLjkyNjI0OSA5LjU1NTYxIDAuNTEzNTE5IDguNzAwOTMgMC4yNjU5NDFDOC4xODQyMyAwLjExNjI3MSA3LjY3MzcgMC4wMzI2OTk5IDcuMTE2OTMgMC4wMDY2NTE4OEM2Ljk5NDE0IDAuMDAwOTA0Njc2IDYuNjUwOCAtMC4wMDA0MDczMjQgNi41NDA5MyAwLjAwNDQ0Mzg4Wk02LjU2MzMzIDEuNjYxODdDNi41NDkyNSAxLjY2Mjk2IDYuNDg4NzcgMS42NjcwMiA2LjQyODkzIDEuNjcwOUM1LjQ0ODM4IDEuNzM0NDIgNC40NTY5MiAyLjExMjkgMy42NjQxMyAyLjcyNjMzQzMuMjIxOTYgMy4wNjg0NiAyLjgyMjI2IDMuNDk2OTQgMi41MTYwMyAzLjk1NzE0QzIuMDY5OTkgNC42Mjc0MiAxLjc4NjY3IDUuMzk3MzEgMS42OTMxOCA2LjE5MzFDMS42NjUyNSA2LjQzMDg0IDEuNjYwOTEgNi41MTYyMyAxLjY2MTMyIDYuODE5MzRDMS42NjE3MiA3LjExOTg3IDEuNjY3NzUgNy4yMjkyNSAxLjY5NjQ4IDcuNDU3MzhDMS43OTU4MyA4LjI0NjI3IDIuMDc2IDguOTk3MzMgMi41MjA4OCA5LjY2NzM0QzIuODAzNDMgMTAuMDkyOSAzLjE5MzQ2IDEwLjUxNjMgMy42MDQyNyAxMC44NDM0QzQuMDk3NzggMTEuMjM2NCA0LjY1NjYgMTEuNTMyOSA1LjI2NzMzIDExLjcyNkM2LjA4NjMgMTEuOTg0OSA2Ljk5NjU1IDEyLjAzMDcgNy44NDc0MSAxMS44NTU4QzguNjQyNTEgMTEuNjkyNCA5LjM5NTA4IDExLjMzOTEgMTAuMDI1NyAxMC44MzNDMTAuMTY5NCAxMC43MTc3IDEwLjI2MjIgMTAuNjM0MyAxMC40MjE1IDEwLjQ3NzNDMTAuNjg5NSAxMC4yMTMxIDEwLjg5MDkgOS45NzE4MyAxMS4wODQ1IDkuNjgzMzRDMTEuNzQ4IDguNjk0NzcgMTIuMDQ2OSA3LjUyMzMgMTEuOTM5MSA2LjMzNDQ4QzExLjg0ODkgNS4zMzk4MSAxMS40NjYxIDQuMzg2MDcgMTAuODQzNCAzLjYwNDI5QzEwLjY4NDIgMy40MDQ0MiAxMC40MzU0IDMuMTM5NTcgMTAuMjU3MyAyLjk4MDUzQzkuNzkyMzkgMi41NjUxMiA5LjI5MzIgMi4yNTM4MSA4LjcyNjUzIDIuMDI1OUM4LjIwMjk0IDEuODE1MzEgNy42Njk2OCAxLjY5NzA4IDcuMDk1NDIgMS42NjQyN0M2Ljk5MzI2IDEuNjU4NDQgNi42MjkwNCAxLjY1NjggNi41NjMzMyAxLjY2MTg3WiIgZmlsbD0iIzhGOEY4RiIvPgo8L3N2Zz4=", er = ({
  isDisabled: t,
  onClick: n,
  label: r,
  placeholder: o,
  error: i = "",
  isRequired: l = !0
}) => {
  const c = yt();
  return /* @__PURE__ */ a(se, { variant: "mobileSelect", isInvalid: !!i, isDisabled: !!t, isRequired: l, children: [
    /* @__PURE__ */ a(
      Me,
      {
        borderRadius: "1.875rem",
        variant: "gradient",
        position: "relative",
        cursor: t ? "not-allowed" : "pointer",
        height: 14,
        fontSize: "md",
        onClick: () => !t && n(),
        pr: 12,
        pl: 4,
        pt: "25px",
        className: `${i ? " errored" : ""}${r === "" ? " empty" : ""}${t ? " disabled" : ""}`,
        __css: {
          "&.focused": {
            ...G.components.Input.variants.just.field._active
          },
          "&.errored": {
            ...G.components.Input.variants.just.field._invalid
          },
          "&.focused + label, &:not(.empty) + label": {
            ...G.components.Form.variants.floating.container._focusWithin.label,
            ...G.components.Form.variants.floating.container._hover.label
          },
          "&.disabled": {
            ...G.components.Input.variants.just.field._disabled
          },
          ...G.components.Input.variants.just.field
        },
        children: [
          r && /* @__PURE__ */ e(
            u,
            {
              noOfLines: 1,
              fontSize: "1rem",
              color: t ? Pe.color : _e.color,
              bg: "transparent",
              children: r
            }
          ),
          /* @__PURE__ */ e(
            Ue,
            {
              right: "10px",
              top: "15px",
              color: t ? "gray.100" : "inherit",
              position: "absolute",
              fontSize: "2xl"
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ e(
      fe,
      {
        requiredIndicator: /* @__PURE__ */ e("abbr", { children: " *" }),
        htmlFor: c,
        bg: "transparent",
        style: {
          backgroundColor: "transparent"
        },
        children: o
      }
    ),
    i && /* @__PURE__ */ e(de, { pl: "4", fontSize: "xs", color: "danger.text", children: i })
  ] });
}, tr = 10, rr = 500, Er = ge(
  ({
    options: t,
    label: n,
    searchLabel: r,
    onChange: o,
    value: i = "",
    error: l,
    isSearchable: c = !0,
    isRequired: d = !0,
    isDisabled: p = !1
  }, g) => {
    const { isOpen: s, onClose: D, onToggle: y } = ct(), [N, h] = x(""), [m, M] = x(""), S = Y(null), T = () => {
      h(""), D();
    };
    E(() => {
      if (S.current && !m) {
        const b = S.current.getBoundingClientRect(), A = window.scrollY + window.innerHeight, k = b.top + window.scrollY;
        M(`${A - k - tr}px`);
      }
    }, [S.current, s]);
    const Q = P(
      () => N !== "" ? t.filter((b) => b.label.toLowerCase().includes(N.toLowerCase())) : t,
      [N, t]
    ), B = Qe((b) => {
      var A;
      h(((A = b.target.value) == null ? void 0 : A.trim()) ?? "");
    }, rr), F = P(
      () => {
        var b;
        return ((b = t.find((A) => A.value === i)) == null ? void 0 : b.label) ?? "";
      },
      [i]
    ), W = w(
      (b) => {
        o == null || o(b), T();
      },
      [o]
    );
    return /* @__PURE__ */ a(I, { position: "relative", children: [
      /* @__PURE__ */ e(
        er,
        {
          label: F,
          placeholder: n,
          onClick: y,
          isRequired: d,
          isDisabled: p,
          error: l
        }
      ),
      s && /* @__PURE__ */ e(
        I,
        {
          overflow: "hidden",
          position: "absolute",
          top: "63px",
          width: "full",
          height: m,
          minH: "300px",
          backgroundColor: "white",
          zIndex: 2,
          ref: S,
          padding: 4,
          borderRadius: "24px",
          border: "1px solid",
          borderColor: "gray.602",
          boxShadow: "2px 2px 10px 0px rgba(0, 0, 0, 0.05), -2px -2px 12px 0px rgba(0, 0, 0, 0.05);",
          children: /* @__PURE__ */ a(O, { spacing: 4, overflow: "scroll", maxH: "100%", children: [
            c && /* @__PURE__ */ a(V, { position: "relative", rounded: "md", children: [
              /* @__PURE__ */ e(
                De,
                {
                  onChange: B,
                  bg: "#F0EFEE",
                  placeholder: r,
                  padding: "8px 12px 8px 44px"
                }
              ),
              /* @__PURE__ */ e(Fe, { children: /* @__PURE__ */ e(H, { src: qt, alt: "search icon", width: "16px", height: "16px" }) })
            ] }),
            i && /* @__PURE__ */ e(ye, { size: "lg", isReadOnly: !0, colorScheme: "fullBlack", isChecked: !0, children: F }),
            /* @__PURE__ */ e($, { borderStyle: "dashed" }),
            /* @__PURE__ */ e(st, { onChange: W, value: i, ref: g, children: /* @__PURE__ */ e(te, { spacing: 6, overflow: "auto", alignItems: "start", children: Q.map(({ value: b, label: A }) => /* @__PURE__ */ e(
              ye,
              {
                variant: "nofloating",
                display: b === i ? "none" : "block",
                size: "lg",
                w: "full",
                isChecked: b === i,
                colorScheme: "fullBlack",
                value: b,
                children: A
              },
              b
            )) }) })
          ] })
        }
      )
    ] });
  }
), Fr = ({
  icon: t,
  title: n,
  sentence: r,
  accept: o,
  decline: i,
  acceptColor: l,
  containerRef: c,
  onDecline: d,
  onAccept: p,
  isOpen: g
}) => {
  const s = Y();
  return /* @__PURE__ */ a(
    dt,
    {
      portalProps: {
        containerRef: c
      },
      motionPreset: "slideInBottom",
      leastDestructiveRef: s,
      onClose: d,
      isOpen: g,
      children: [
        /* @__PURE__ */ e(gt, {}),
        /* @__PURE__ */ a(
          ut,
          {
            maxWidth: "calc(100% - 100px)",
            alignContent: "center",
            alignItems: "center",
            justifyContent: "center",
            children: [
              /* @__PURE__ */ e(I, { display: "flex", justifyContent: "center", p: "4", children: t }),
              /* @__PURE__ */ e(Mt, { pt: "1", pb: "1", textAlign: "center", fontWeight: "medium", lineHeight: "6", children: n }),
              /* @__PURE__ */ e(ht, { fontSize: "sm", color: "#1C1C1C", textAlign: "center", lineHeight: "5", children: r }),
              /* @__PURE__ */ e(It, { children: /* @__PURE__ */ a(O, { width: "100%", children: [
                /* @__PURE__ */ e($, {}),
                /* @__PURE__ */ e(Z, { variant: "ghost", color: l ?? "#1C1C1C", onClick: p, children: o }),
                /* @__PURE__ */ e($, {}),
                /* @__PURE__ */ e(Z, { onClick: d, variant: "ghost", children: i })
              ] }) })
            ]
          }
        )
      ]
    }
  );
};
const nr = ({
  isOpen: t,
  closedLabel: n,
  closedIconPath: r,
  title: o,
  openIcon: i,
  ...l
}) => /* @__PURE__ */ a(
  C,
  {
    w: "full",
    h: "2.625rem",
    position: "absolute",
    cursor: "pointer",
    top: "0",
    zIndex: 1001,
    pt: 1.5,
    px: 4,
    pb: 0,
    justifyContent: "center",
    gap: 2,
    borderTopRadius: "3xl",
    bg: "#FFF",
    ...l,
    children: [
      /* @__PURE__ */ e(
        I,
        {
          w: "3rem",
          h: "0.25rem",
          bg: "#D9D9D9",
          borderRadius: "0.125rem",
          className: "dash",
          left: "50%",
          transform: "translateX(-50%)",
          position: "absolute"
        }
      ),
      /* @__PURE__ */ a(C, { justifyContent: "center", alignSelf: "center", alignContent: "center", alignItems: "center", mt: 2, children: [
        /* @__PURE__ */ e(
          H,
          {
            src: r,
            alt: "CartIcon",
            position: "absolute",
            display: t ? "none" : "flex",
            top: "4",
            left: "4"
          }
        ),
        /* @__PURE__ */ e(
          u,
          {
            color: "#585858",
            textAlign: "center",
            fontWeight: "medium",
            lineHeight: "6",
            display: t ? "none" : "flex",
            position: "absolute",
            top: "4",
            left: "12",
            children: n
          }
        ),
        /* @__PURE__ */ e(
          u,
          {
            color: "#585858",
            textAlign: "center",
            fontWeight: "medium",
            lineHeight: "6",
            display: t ? "flex" : "none",
            children: o
          }
        )
      ] }),
      !t && i && /* @__PURE__ */ e(
        H,
        {
          src: i,
          alt: "cart icon",
          fill: "#8F8F8F",
          pl: 4,
          pt: 2,
          position: "absolute",
          top: "4",
          right: "4"
        }
      ),
      t && /* @__PURE__ */ e(
        ue,
        {
          boxSize: "0.75rem",
          color: "#8F8F8F",
          "aria-description": "justDrawerCloseIcon",
          position: "absolute",
          top: "6",
          right: "6"
        }
      )
    ]
  }
);
function or() {
  const t = document.createElement("div");
  return t.setAttribute("id", "superdrawer-root"), t;
}
const ir = 300, lr = 30, Lr = () => {
  const [t, n] = x(!1), r = w(() => {
    n(!t);
  }, [t]), o = w(() => {
    n(!0);
  }, [t]), i = w(() => {
    n(!1);
  }, [t]);
  return { isOpen: t, onToggle: r, onClose: i, onOpen: o };
}, kr = ({
  children: t,
  onClose: n,
  onOpen: r,
  isOpen: o,
  position: i = "bottom",
  title: l,
  removeWhenClosed: c = !0,
  isFullHeight: d = !1,
  size: p = "unset",
  containerRef: g,
  closedLabel: s = "",
  fixFooter: D,
  closedIconPath: y = "",
  onSwipeOpened: N,
  onClickOpened: h,
  onSwipeClosed: m,
  onClickClosed: M,
  openIcon: S
}) => {
  const T = Y(), Q = Y(null), z = Y(null), [B, F] = x("rgba(255, 255, 255, 0.80)"), [W, b] = x(0);
  E(() => {
    T.current = document.getElementById("superdrawer-root") ?? or();
  }, []);
  const A = Ge(o, ir);
  E(() => {
    (() => {
      g != null && g.current && (o ? g.current.style.overflow = "hidden" : g.current.style.overflow = "");
    })();
  }, [g, o]);
  const k = w(
    (j) => {
      j.key === "Escape" && o && n();
    },
    [n]
  ), Ie = w(() => {
    o ? (n(), M == null || M()) : (r(), h == null || h());
  }, [n, M, r, h]), pe = w(
    (j) => {
      j.target instanceof HTMLElement && j.target.classList.contains("justdrawer-overlay-wrapper") && n();
    },
    [n]
  ), [_, me] = x(0), [f, ae] = x({
    start: 0,
    newHeight: 0,
    startHeight: 0,
    swipeUpLocked: !1,
    swipeDownLocked: !1,
    lastActionAborted: !1
  }), Ze = w(
    (j) => {
      var xe, je, ze, Ae, we;
      if (!j.touches[0] || !(z != null && z.current))
        return;
      const v = ((xe = z.current) == null ? void 0 : xe.scrollTop) + ((je = z.current) == null ? void 0 : je.clientHeight) === ((ze = z.current) == null ? void 0 : ze.scrollHeight), Je = ((Ae = z.current) == null ? void 0 : Ae.scrollTop) == 0;
      me(window.innerHeight), ae({
        lastActionAborted: !1,
        swipeUpLocked: o && !v,
        swipeDownLocked: o && !Je,
        start: j.touches[0].clientY,
        newHeight: 0,
        startHeight: ((we = z == null ? void 0 : z.current) == null ? void 0 : we.clientHeight) ?? 0
      });
    },
    [o, z, z]
  ), Ve = w(() => {
    f.newHeight !== 0 && (f.lastActionAborted || (f.newHeight > lr * (_ / 100) ? (r(), N == null || N()) : (n(), m == null || m())), ae({
      start: 0,
      newHeight: 0,
      startHeight: 0,
      swipeDownLocked: !1,
      swipeUpLocked: !1,
      lastActionAborted: !1
    }));
  }, [f]), $e = w(
    (j) => {
      if (!j.touches[0])
        return;
      if (f.swipeDownLocked && j.touches[0].clientY - f.start > 0 || f.swipeUpLocked && j.touches[0].clientY - f.start < 0) {
        ae({
          ...f,
          lastActionAborted: !0
        });
        return;
      }
      let v = j.touches[0].clientY - f.start < 0 ? Math.abs(j.touches[0].clientY - f.start) + f.startHeight : f.startHeight - Math.abs(j.touches[0].clientY - f.start);
      v = v < 0 ? 1 : v, ae({
        ...f,
        newHeight: v
      });
    },
    [f]
  );
  return E(() => {
    if (f.newHeight) {
      const j = f.newHeight / (_ / 2), v = Math.abs(j < 0.8 ? j : 0.8);
      F(`rgba(255, 255, 255, ${v})`), b(v);
    } else
      o ? (F("rgba(255, 255, 255, 0.80)"), b(1)) : (F("rgba(255, 255, 255, 0)"), b(0));
  }, [f.newHeight, o]), E(() => (document.addEventListener("keydown", k, !1), () => document.removeEventListener("keydown", k, !1)), [k]), E(() => {
    if (!(g != null && g.current) || !(T != null && T.current))
      return;
    g.current.appendChild(T.current);
    const j = g.current;
    return () => {
      j.style.overflow = "";
    };
  }, [g]), !A && c && !o || !T.current ? null : Be(
    /* @__PURE__ */ e(
      "div",
      {
        "aria-hidden": o ? "false" : "true",
        className: `justdrawer-container ${o || f.newHeight ? "open" : ""} ${A || f.newHeight ? "in" : ""} ${f.newHeight ? "swiping" : ""}`,
        children: /* @__PURE__ */ e(
          I,
          {
            className: "justdrawer-overlay-wrapper",
            backgroundColor: B,
            onClick: (j) => o && pe(j),
            children: /* @__PURE__ */ a(
              I,
              {
                onTouchStart: Ze,
                onTouchEnd: Ve,
                onTouchMove: $e,
                roundedTop: d ? "none" : "3xl",
                boxShadow: "0px -2px 12px 0px rgba(0, 0, 0, 0.08)",
                className: `justdrawer ${i}`,
                role: "dialog",
                ref: Q,
                pt: !o && c ? 0 : "46px",
                height: d && o && !f.newHeight ? "full" : "unset",
                children: [
                  /* @__PURE__ */ e(
                    nr,
                    {
                      isOpen: o,
                      title: l,
                      closedLabel: s,
                      closedIconPath: y,
                      onClick: Ie,
                      openIcon: S
                    }
                  ),
                  /* @__PURE__ */ e(
                    I,
                    {
                      className: "justdrawer-content",
                      overflowY: "scroll",
                      alignItems: "center",
                      alignContent: "center",
                      px: 4,
                      ref: z,
                      opacity: W,
                      height: f.newHeight ? `${f.newHeight}px` : o ? d ? "full" : p : 0,
                      children: t
                    }
                  ),
                  /* @__PURE__ */ e(I, { px: 4, mt: 2, children: D })
                ]
              }
            )
          }
        )
      }
    ),
    T.current
  );
}, vr = ({ children: t, ...n }) => /* @__PURE__ */ e(u, { lineHeight: "24px", fontSize: "1.125rem", className: "leaf__heading", ...n, children: t }), Or = ({ children: t, ...n }) => /* @__PURE__ */ e(u, { lineHeight: "6", fontSize: "md", fontStyle: "normal", fontWeight: "350", className: "leaf__body", ...n, children: t }), Ur = ({ children: t, ...n }) => /* @__PURE__ */ e(u, { fontSize: "md", fontWeight: "medium", lineHeight: "6", className: "leaf__caption", ...n, children: t }), Yr = ({ children: t, ...n }) => /* @__PURE__ */ e(
  u,
  {
    color: "#1C1C1C",
    fontSize: "0.75rem",
    lineHeight: "20px",
    fontWeight: 600,
    className: "leaf__info",
    ...n,
    children: t
  }
), ar = ({ ...t }) => /* @__PURE__ */ e(pt, { sx: be.baseStyle, ...t, children: t.children });
ar.defaultProps = {
  variant: "primary"
};
const Hr = ({ components: t, show: n }) => /* @__PURE__ */ e(ee, { children: t[n] });
export {
  Or as Body,
  Me as BoxGradient,
  We as Button,
  Ur as Caption,
  jt as Card,
  fr as Cart,
  Fr as Confirm,
  ar as CustomCheckbox,
  Ft as Discounts,
  Hr as DisplaySwitcher,
  xr as Drawer,
  br as Dropdown,
  vr as Heading,
  Yr as Info,
  Ne as Input,
  Nr as InputRhf,
  Re as InputWithIcon,
  Dr as InputWithIconRhf,
  kr as JustDrawer,
  Er as MobileSelect,
  wr as PhoneInput,
  Tr as PinInput,
  Cr as PlaceholderDropdown,
  Sr as PlaceholderDropdownCard,
  Ar as Radio,
  zr as SuperDrawer,
  G as theme,
  Lr as useJustDrawer,
  jr as useSuperDrawer
};
